var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{ref:"modal",attrs:{"show-close-button":false,"submit-value":"OK","title":_vm.headerTitle,"modal-class":"modal-msg"},on:{"ok":_vm.ok}})}
var staticRenderFns = []

export { render, staticRenderFns }